var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneCallOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_194_2461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7002 1.79999C12.779 2.08953 13.7627 2.65773 14.5526 3.44758C15.3425 4.23744 15.9107 5.22115 16.2002 6.29999",
    stroke: "#FF5900",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7998 4.5C11.4479 4.67212 12.039 5.01251 12.5131 5.48667C12.9873 5.96083 13.3277 6.5519 13.4998 7.2",
    stroke: "#FF5900",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17327 8.60269C6.85905 10.0189 8.00419 11.1611 9.42213 11.8432C9.52672 11.8927 9.64241 11.9142 9.7578 11.9054C9.8732 11.8967 9.98432 11.858 10.0802 11.7932L12.1628 10.4021C12.2548 10.3396 12.3612 10.3016 12.4719 10.2914C12.5826 10.2812 12.6941 10.2992 12.7959 10.3437L16.6946 12.0182C16.8278 12.0736 16.9391 12.1713 17.0114 12.2963C17.0836 12.4212 17.1128 12.5664 17.0944 12.7096C16.9709 13.674 16.5001 14.5604 15.7703 15.2029C15.0404 15.8453 14.1015 16.1998 13.1292 16.2C10.1244 16.2 7.24276 15.0064 5.1181 12.8817C2.99343 10.7571 1.7998 7.8754 1.7998 4.87066C1.80002 3.89834 2.15453 2.9594 2.79698 2.22955C3.43943 1.49971 4.3258 1.02896 5.29025 0.905388C5.4334 0.887001 5.57862 0.916179 5.70356 0.988432C5.82849 1.06068 5.92621 1.172 5.98167 1.30525L7.65608 5.21221C7.69963 5.31247 7.71784 5.42189 7.70913 5.53084C7.70041 5.6398 7.66503 5.74494 7.6061 5.83699L6.21492 7.95292C6.15299 8.04862 6.11663 8.15861 6.10934 8.27237C6.10205 8.38613 6.12406 8.49986 6.17327 8.60269Z",
    stroke: "#FF5900",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_194_2461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCallOrange);
export default __webpack_public_path__ + "static/media/phone-call-orange.651638bc8bbcdb95e9e2cfa4bc61359d.svg";
export { ForwardRef as ReactComponent };